// CHANGE THIS TO https://www.atomcms.dev/api
export const baseAPIRoute = 'https://atomcms.vercel.app/api';
// export const baseAPIRoute = 'http://localhost:3000/api';
